// extracted by mini-css-extract-plugin
module.exports = {"AboutUs":"aboutUs_AboutUs__2Lkmn","AboutUsBg":"aboutUs_AboutUsBg__2gTtj","ManImage":"aboutUs_ManImage__XGmtz","FirstHeader":"aboutUs_FirstHeader__3qWSf"};